import React from 'react'
import { graphql } from 'gatsby'
import parse from 'html-react-parser'


import Gallery from '../components/homes/galleryImages'
import SEO from '../components/seo/seo'
import Link from '../components/link/link'
import RequestCallback from '../components/request-callback/request-callback'
import ContentHome from '../components/homes/contentHome'


const HolidayParkSingle = ({ data: { wpHolidaypark, homesParent, holidayParks, wp: { homeOfTheWeek } } }) => {
    const galleryData = []
    wpHolidaypark?.holidayparkFields?.gallery?.map(item => {
        const thumbnail = item?.mediaDetails?.sizes?.find(item => item.name === 'thumbnail')
        galleryData.push({
            localFile: item.localFile,
            photo: item.sourceUrl,
            caption: item.caption ? item.caption : '',
            thumbnail: thumbnail ? thumbnail.sourceUrl : '',
        })
    })
    return (
        <>
            <SEO {...wpHolidaypark.seo } />
              {
                    wpHolidaypark.holidayparkFields.gallery &&
                    <Gallery photos={galleryData} />
              }

            <section className="pb-8 md:pb-12 lg:pb-16 pt-5 bg-tan-50">

                <div className="container mt-4 lg:mt-8 max-w-5xl">
                    <div className="w-full flex flex-wrap relative lg:-mx-4">
                        <div className="w-full lg:w-2/3 lg:px-4 mb-4 lg:mb-0">
                                <div className="flex flex-wrap items-center justify-between">
                                    <h1 className="font-serif text-4xl lg:text-5xl text-tan-700 mb-1 xl:mb-2">{ parse(wpHolidaypark.title) }</h1>
                                    <div className="ml-3">
                                        <span className={`${wpHolidaypark.holidayparkFields.ownershipType === 'p' ? `bg-blue`: `bg-tan-800`} font-bold uppercase w-6 h-6 text-white inline-flex items-center justify-center text-xs ml-auto rounded-full`}>{parse(wpHolidaypark.holidayparkFields.ownershipType)}</span>
                                    </div>
                                </div>
                                {
                                    wpHolidaypark.holidayparkFields.description &&
                                    <h2 className="text-base">{ parse(wpHolidaypark.holidayparkFields.address) }</h2>
                                }
                                <div className="border-b border-tan-500 mt-2 mb-3 lg:mb-8"></div>
                                {
                                    wpHolidaypark.holidayparkFields.description &&
                                    <div className="prose">{ parse(wpHolidaypark.holidayparkFields.description) }</div>
                                }
                                <div className="mt-6">
                                    <div className={'inline-block mb-1 mr-3'}>
                                      <span className="font-bold uppercase w-5 h-5 text-white bg-tan-800 inline-flex items-center justify-center text-xs ml-auto rounded-full">R</span>
                                      <span className="text-sm ml-2">Parks where owners may rent their Holiday Home.</span>
                                    </div>
                                    <div className={'inline-block mb-1 mr-3'}>
                                      <span className="font-bold uppercase w-5 h-5 bg-tan-100 text-tan-800 inline-flex items-center justify-center text-xs ml-auto rounded-full">P</span>
                                      <span className="text-sm ml-2">Parks where only the owners can use the Holiday Homes.</span>
                                    </div>
                                </div>
                                <div className="flex flex-wrap items-center space-x-5 mt-4">

                                    {
                                        holidayParks && holidayParks.nodes.length &&
                                        <Link className="border border-tan-300 text-sm text-black font-bold flex items-center px-6 justify-center hover:bg-tan-700 hover:text-white hover:border-tan-700 py-3 rounded-full transition duration-500 ease-in-out my-1" to={holidayParks.nodes[0].parentLink}>
                                          <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5 mr-2 fill-current stroke-current" viewBox="0 0 16 16"><g strokeWidth="1"><ellipse cx="8.5" cy="8.5" rx="3" ry="7" fill="none" strokeLinecap="round" strokeLinejoin="round"></ellipse> <line x1="1.5" y1="8.5" x2="15.5" y2="8.5" fill="none" strokeLinecap="round" strokeLinejoin="round"></line> <circle cx="8.5" cy="8.5" r="7" fill="none" strokeLinecap="round" strokeLinejoin="round"></circle></g></svg>
                                          Back to holiday parks
                                        </Link>
                                    }
                                    {
                                        homesParent && homesParent.nodes.length &&
                                        <Link className="text-sm text-white font-bold flex items-center px-6 justify-center bg-tan-800 hover:bg-black py-3 rounded-full transition duration-500 ease-in-out my-1" to={homesParent.nodes[0].parentLink}>
                                          <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4 mr-3 fill-current stroke-current" viewBox="0 0 32 32"><g strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" transform="translate(0.5 0.5)"><polyline points="1 14 16 2 31 14" fill="none" strokeMiterlimit="10"></polyline><polyline points="5 16 5 30 18 30" fill="none" strokeMiterlimit="10"></polyline><circle cx="24" cy="21" r="1" data-stroke="none" stroke="none"></circle><path d="M30,20.844C30,24.451,24,30,24,30s-6-5.549-6-9.156A5.874,5.874,0,0,1,24,15,5.874,5.874,0,0,1,30,20.844Z" fill="none" strokeMiterlimit="10"></path></g></svg>
                                          Now find your holiday home
                                        </Link>
                                    }
                                </div>




                        </div>
                        <div className="w-full lg:w-1/3 lg:px-4">
                            <div className="lg:max-w-sm">
                                {
                                    homeOfTheWeek?.homeOfTheWeek?.home &&
                                    <div className="relative mt-12 lg:mt-3 w-full">
                                        <h3 className="font-serif text-center mb-4">Home of the week</h3>
                                        <ContentHome  
                                          isHome={true}
                                          {...homeOfTheWeek?.homeOfTheWeek?.home}
                                        />
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section id="contact" className="bg-tan-500 py-16 lg:py-20">
                <RequestCallback title={'Request a call back'} />
            </section>

        </>
    )
}

export const query = graphql`
query HolidayParkByID($databaseId: IntQueryOperatorInput!) {
  wpHolidaypark(databaseId: $databaseId) {
    title
    seo {
      title
      canonical
      focuskw
      metaDesc
      metaRobotsNoindex
      metaRobotsNofollow
      opengraphTitle
      opengraphDescription
      opengraphImage {
        altText
        sourceUrl
      }
      twitterTitle
      twitterDescription
      twitterImage {
        altText
        sourceUrl
      }
    }
    holidayparkFields {
      address
      description
      ownershipType
      gallery {
        altText
        sourceUrl
        caption
        localFile {
          childImageSharp {
            gatsbyImageData(
              width: 1800, 
              quality: 100,
              layout: FULL_WIDTH
            )
          }
        }
        mediaDetails {
          sizes {
            sourceUrl
            name
          }
        }
      }
    }
  }
  homesParent: allWpPage(filter: {mytemplate: {eq: "homesIndex"}}) {
    nodes {
      parentLink: relativelink
    }
  }
  holidayParks: allWpPage(filter: {mytemplate: {eq: "holidayParksIndex"}}) {
    nodes {
      parentLink: relativelink
    }
  }
  wp {
    homeOfTheWeek {
      homeOfTheWeek {
        home {
          ... on WpHome {
            title
            relativelink
            home {
              bathrooms
              bedrooms
              salePrice
              salePriceOld
              shortDescription
              size
              year
              sleeps
              decking
            }
            featuredImage {
                node {
                  title
                  altText
                  sourceUrl
                  localFile {
                    childImageSharp {
                      gatsbyImageData(width: 700)
                    }
                  }
                }
            }
          }
        }
      }
    }
  }
}
`
export default HolidayParkSingle
